import { render, staticRenderFns } from "./business_review.vue?vue&type=template&id=6898107a&scoped=true"
import script from "./business_review.vue?vue&type=script&lang=js"
export * from "./business_review.vue?vue&type=script&lang=js"
import style0 from "./business_review.vue?vue&type=style&index=0&id=6898107a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6898107a",
  null
  
)

export default component.exports